var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from "react";
import * as classnames from "classnames";
import * as uuidV4 from "uuid/v4";
import Label from "../internal/Label";
var Select = function (_a) {
    var label = _a.label, className = _a.className, _b = _a.stretched, stretched = _b === void 0 ? false : _b, _c = _a.id, id = _c === void 0 ? uuidV4() : _c, color = _a.color, children = _a.children, _d = _a.wdsSize, wdsSize = _d === void 0 ? "md" : _d, otherProps = __rest(_a, ["label", "className", "stretched", "id", "color", "children", "wdsSize"]);
    var _e;
    return (React.createElement(React.Fragment, null,
        label && React.createElement(Label, { htmlFor: id }, label),
        React.createElement("div", { className: classnames("wds-select", { "wds-select--stretched": stretched }, (_e = {}, _e["wds-select--" + color] = !!color, _e), { "wds-select--multi": otherProps.multiple }, "wds-select--" + wdsSize, className) },
            React.createElement("select", __assign({ "aria-label": label, id: id }, otherProps), children))));
};
export default Select;
//# sourceMappingURL=Select.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/Select/Select.js
// module id = 1806
// module chunks = 17